package com.milta.feature.auth.presentation

sealed interface OtpNavEvent {
    /** @param role JWT role claim value: "Driver" or "Enterprise". */
    data class NavigateToHome(val role: String) : OtpNavEvent
    object NavigateBack : OtpNavEvent
}
